<script lang="ts">
import { ContactInfo } from "@/dashboard/my-account/contact-info/contact-info";
export default ContactInfo;
</script>

<template>
    <div class="account__tab tab--1 is-open">
        <form class="account__form" @submit="onSubmit">
            <div class="row row--account">
                <div class="col-12 col-xl-6">
                    <h5 class="account__title">
                        <i18n-t
                            keypath="dashboard.myAccountComponent.contactInfoTab.generalInfo"
                        />
                    </h5>
                    <div class="row form__field app-disabled">
                        <div
                            class="col form__col"
                            :class="{
                                'form__group--active': idFocused || userDto?.id,
                            }"
                        >
                            <input
                                class="form__input"
                                :value="userDto?.id"
                                tabindex="-1"
                            />
                            <label class="form__label required">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.contactInfoTab.userid"
                                />
                            </label>
                        </div>
                    </div>
                    <div class="row form__field">
                        <div
                            class="col form__col"
                            :class="{
                                'form__group--active':
                                    firstnameFocused || form.values.firstname,
                            }"
                        >
                            <input
                                class="form__input"
                                name="firstname"
                                v-model="form.values.firstname"
                                @focus="firstnameFocused = true"
                                @blur="firstnameFocused = false"
                                :class="{ '--error': form.errors.firstname }"
                            />
                            <label class="form__label required">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.contactInfoTab.fname"
                                />
                            </label>
                        </div>
                    </div>
                    <div class="row form__field">
                        <div
                            class="col form__col"
                            :class="{
                                'form__group--active':
                                    lastnameFocused || form.values.lastname,
                            }"
                        >
                            <input
                                class="form__input"
                                name="lastname"
                                @focus="lastnameFocused = true"
                                @blur="lastnameFocused = false"
                                v-model="form.values.lastname"
                                :class="{ '--error': form.errors.lastname }"
                            />
                            <label class="form__label required">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.contactInfoTab.lname"
                                />
                            </label>
                        </div>
                    </div>
                    <div class="row form__field app-disabled">
                        <div
                            class="col form__col"
                            :class="{
                                'form__group--active': emailFocused || userDto?.email,
                            }"
                        >
                            <input
                                class="form__input"
                                :value="userDto?.email"
                                tabindex="-1"
                            />
                            <label class="form__label required">E-mail</label>
                        </div>
                    </div>
                    <div class="row form__field">
                        <div class="col form__col select__col">
                            <div
                                class="select"
                                :class="{ '--error': form.errors.id_language }"
                            >
                                <div class="select__label required">
                                    <i18n-t
                                        keypath="dashboard.myAccountComponent.contactInfoTab.language"
                                    />
                                </div>
                                <app-dropdown
                                    v-model="form.values.id_language"
                                    @focus="languageFocused = true"
                                    @blur="languageFocused = false"
                                    name="language"
                                    :placeholder="i18n.t('common.subjectPlaceholder')"
                                    :type="'single'"
                                    :get-label="(language) => language.name"
                                    :get-value="(language) => language.id"
                                    :options="languageOptions"
                                    :showCheckbox="false"
                                ></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="row form__field">
                        <div class="col form__col select__col">
                            <div
                                class="select"
                                :class="{ '--error': form.errors.id_gender }"
                            >
                                <div class="select__label required">
                                    <i18n-t
                                        keypath="dashboard.myAccountComponent.contactInfoTab.gender"
                                    />
                                </div>
                                <app-dropdown
                                    v-model="form.values.id_gender"
                                    @focus="genderFocused = true"
                                    @blur="genderFocused = false"
                                    name="gender"
                                    :placeholder="i18n.t('common.subjectPlaceholder')"
                                    :type="'single'"
                                    :get-label="(gender) => gender.name"
                                    :get-value="(gender) => gender.id"
                                    :options="genderOptions"
                                    :showCheckbox="false"
                                ></app-dropdown>
                            </div>
                        </div>
                    </div>
                    <div class="row form__field">
                        <div class="col form__col select__col">
                            <div class="select">
                                <div class="select__label required">
                                    <i18n-t
                                        keypath="dashboard.myAccountComponent.contactInfoTab.dateOfBirth"
                                    />
                                </div>
                            </div>
                            <p-calendar
                                v-model="form.values.date_of_birth"
                                :placeholder="'dd/mm/yyyy'"
                                id="date_of_birth"
                                selectionMode="single"
                                :manualInput="true"
                                :dateFormat="'dd/mm/yy'"
                                @input="onKeyDate"
                            />
                        </div>
                    </div>
                    <div class="row form__field">
                        <div
                            style="display: flex; align-items: center"
                            class="d-flex flex-row checkbox"
                        >
                            <input
                                id="marketing_subscription"
                                type="checkbox"
                                name="marketing_subscription"
                                v-model="form.values.marketing_subscription"
                                @focus="marketingSubscriptionFocused = true"
                                @blur="marketingSubscriptionFocused = false"
                                :class="{ '--error': form.errors.marketing_subscription }"
                            />
                            <label for="marketing_subscription" class="required" style="padding-left: 10px">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.contactInfoTab.marketingSubscription"
                                />
                            </label>
                        </div>
                    </div>
                    <div class="row form__field">
                        <div
                            style="display: flex; align-items: center"
                            class="d-flex flex-row checkbox"
                        >
                            <input
                                id="marketing_on_company_profile"
                                type="checkbox"
                                name="marketing_on_company_profile"
                                v-model="form.values.marketing_on_company_profile"
                                @focus="marketingOnCompanyProfileFocused = true"
                                @blur="marketingOnCompanyProfileFocused = false"
                                :class="{ '--error': form.errors.marketing_on_company_profile }"
                            />
                            <label for="marketing_on_company_profile" class="required" style="padding-left: 10px">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.contactInfoTab.marketingOnCompanyProfile"
                                />
                            </label>
                        </div>
                    </div>
                    <div class="row form__field app-disabled">
                        <div
                            class="col form__col"
                            :class="{
                                'form__group--active': roleFocused || userDto?.role.id,
                            }"
                        >
                            <input
                                class="form__input"
                                :value="userDto?.role.name"
                                tabindex="-1"
                            />
                            <label class="form__label required">
                                <i18n-t
                                    keypath="dashboard.myAccountComponent.contactInfoTab.role"
                                />
                            </label>
                        </div>
                    </div>
                </div>
                <div class="col-12 col-xl-6">
                    <div v-if="!shouldHideContactInfo">
                        <h5 class="account__title">
                            <i18n-t
                                keypath="dashboard.myAccountComponent.contactInfoTab.managerTitle"
                            />
                        </h5>
                        <app-account-manager />
                    </div>
                    <div class="phone-head">
                        <h5 class="account__title">
                            <i18n-t
                                keypath="dashboard.myAccountComponent.contactInfoTab.phones"
                            />
                        </h5>
                        <!-- кнопка добавления -->
                        <div role="row">
                            <div class="text-left" aria-sort="none">
                                <div
                                    v-tippy="{
                                        content: isViewer
                                            ? i18n.t('common.denyText')
                                            : undefined,
                                        placement: 'auto',
                                    }"
                                >
                                    <a
                                        class="js-add-location dashboard__add-location"
                                        :class="{ 'is-disabled': isViewer }"
                                        @click="() => createPhoneNumberRow()"
                                    >
                                        <svg class="sprite-icon" width="12" height="12">
                                            <use xlink:href="/img/sprite.svg#plus"></use>
                                        </svg>
                                        <span>
                                            <i18n-t
                                                keypath="dashboard.myAccountComponent.companyInfoTab.addPhoneNumber"
                                            />
                                        </span>
                                    </a>
                                </div>
                            </div>
                        </div>
                    </div>
                    <!-- список телефонов -->
                    <div
                        v-for="phoneNumber in phoneNumbers"
                        :key="String(phoneNumber.id)"
                        role="row"
                        class="row form__field account__form"
                        :class="{ 'app-disabled': isViewer }"
                    >
                        <div class="col form__col form__group--active phone-block">
                            <div class="account__phone-type required">
                                <div>
                                    <div
                                        class="select"
                                        v-if="phoneNumber.edit && phoneNumber.id == null"
                                    >
                                        <app-dropdown
                                            v-if="phoneNumber.id === null"
                                            v-model="phoneNumber.type"
                                            @focus="phoneNumberTypeFocused = true"
                                            @blur="phoneNumberTypeFocused = false"
                                            name="phoneType"
                                            :placeholder="phoneNumber?.type?.name || ''"
                                            :type="'single'"
                                            :get-label="(phoneType) => phoneType.name"
                                            :get-value="(phoneType) => phoneType.id"
                                            :options="phoneNumberType"
                                            :showCheckbox="false"
                                        ></app-dropdown>
                                        <input
                                            v-else
                                            class="form__input"
                                            name="lastname"
                                            :value="phoneNumber.type?.name || ''"
                                            disabled
                                        />
                                    </div>
                                    <div v-else class="select">
                                        <span>{{ phoneNumber?.type?.name }}</span>
                                    </div>
                                </div>
                            </div>
                            <vue-tel-input
                                v-if="phoneNumber.edit"
                                v-model="phoneNumber.number"
                                v-bind="phoneProps(phoneNumber.number)"
                                @validate="
                                    (phoneObject) =>
                                        validatePhone(phoneObject, phoneNumber.number)
                                "
                                @input="validateInput"
                                @focus="handleFocus(phoneNumber.number)"
                                :inputOptions="{ readonly: !phoneNumber.edit }"
                            />
                            <div v-else>
                                <span>{{ phoneNumber.number }}</span>
                            </div>
                            <div class="account__actions">
                                <!-- редактирование -->
                                <!-- сохранение -->
                                <div
                                    v-tippy="{
                                        content: isViewer
                                            ? i18n.t('common.denyText')
                                            : undefined,
                                        placement: 'auto',
                                    }"
                                >
                                    <a
                                        class="dashboard__table-link"
                                        href="#"
                                        :class="{ 'is-disabled': isViewer }"
                                        title="Update"
                                        @click="() => uploadPhone(phoneNumber)"
                                    >
                                        <svg
                                            v-if="
                                                !phoneNumber.edit &&
                                                phoneNumber.id !== null
                                            "
                                            class="sprite-icon dashboard__table-icon"
                                            width="18"
                                            height="18"
                                        >
                                            <use xlink:href="/img/sprite.svg#edit"></use>
                                        </svg>
                                        <svg
                                            v-if="
                                                phoneNumber.edit &&
                                                phoneNumber.phoneNumberIsValid &&
                                                phoneNumber.id !== null
                                            "
                                            class="sprite-icon dashboard__table-icon"
                                            width="18"
                                            height="18"
                                        >
                                            <use
                                                xlink:href="/img/sprite.svg#check-circle2"
                                            ></use>
                                        </svg>
                                        <svg
                                            v-if="
                                                phoneNumber.phoneNumberIsValid &&
                                                phoneNumber.id === null &&
                                                phoneNumber.type !== null
                                            "
                                            class="sprite-icon dashboard__table-icon"
                                            width="18"
                                            height="18"
                                        >
                                            <use
                                                xlink:href="/img/sprite.svg#check-circle2"
                                            ></use>
                                        </svg>
                                    </a>
                                </div>
                                <!-- удаление существующего -->
                                <div
                                    v-tippy="{
                                        content: isViewer
                                            ? i18n.t('common.denyText')
                                            : undefined,
                                        placement: 'auto',
                                    }"
                                    v-if="phoneNumber.id !== null"
                                >
                                    <a
                                        :class="{ 'is-disabled': isViewer }"
                                        class="
                                            dashboard__table-link
                                            dashboard__table-link_warning
                                        "
                                        href="#"
                                        title="Delete"
                                        @click="() => deletePhone(phoneNumber)"
                                    >
                                        <svg
                                            class="sprite-icon dashboard__table-icon"
                                            width="18"
                                            height="18"
                                        >
                                            <use
                                                xlink:href="/img/sprite.svg#icon-delete"
                                            ></use>
                                        </svg>
                                    </a>
                                </div>
                                <a
                                    v-else
                                    class="
                                        dashboard__table-link
                                        dashboard__table-link_warning
                                    "
                                    href="#"
                                    title="Cancel"
                                    @click="() => deletePhone(phoneNumber)"
                                >
                                    <svg
                                        class="sprite-icon dashboard__table-icon"
                                        width="18"
                                        height="18"
                                    >
                                        <use xlink:href="/img/sprite.svg#decline"></use>
                                    </svg>
                                </a>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-12">
                    <div class="row form__field">
                        <div class="col form__col btn__col">
                            <button class="button" type="submit">
                                <i18n-t keypath="dashboard.myAccountComponent.saveBtn" />
                                <span
                                    v-if="isLoading"
                                    style="
                                        margin-left: 10px;
                                        margin-top: 1px;
                                        position: absolute;
                                    "
                                    class="p-button-loading-icon pi pi-spinner pi-spin"
                                ></span>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    </div>
</template>
<style scoped lang="scss">
:global(#date_of_birth.bday-calendar) {
    font-size: 1rem;
    font-weight: 400;
}

.phone-block {
    padding: 13px 82px 13px 20px;
    margin-left: 10px;
    max-width: calc(100% - 20px);
    background-color: white;
    margin-bottom: 8px;
    box-shadow: 0 30px 60px rgba(#283747, 0.1);

    .account__actions {
        bottom: 15px;
        display: flex;
    }
}
.phone-head {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
}
a.is-disabled {
    opacity: 0.4;
    pointer-events: none;
}
</style>
